import axios from '../axios-config';

/*
===============================|> All Checkout APis <|===============================
01 |--> get Regions,
02 |--> get User addresses,
03 |--> get available shipping methods,
04 |--> add bundle products to cart,
05 |--> get available payments,
===============================|> All Checkout APis <|===============================
*/

const getRegions = async () => {
  let config = {
    method: 'get',
    url: '/mstore/region',
  };
  try {
    const req = await axios(config);
    return req;
  } catch (error) {
    return error;
  }
};

const getRegionsV2 = async (locale) => {
  let config = {
    baseURL: process.env.NEXT_PUBLIC_API_BASEURL.replace('v1', 'v2'),
    method: 'get',
    url: `/mstore/region/${locale}`,
  };

  console.log('config ---------- ', config);
  try {
    const req = await axios(config);
    return req;
  } catch (error) {
    return error;
  }
};

// 02- ============= get regions data
const getUserAddresses = async (mage) => {
  let config = {
    method: 'get',
    url: '/customer/address',
    headers: {
      mage: 'Bearer ' + mage,
    },
  };
  try {
    const req = await axios(config);
    return req;
  } catch (error) {
    return error;
  }
};

// 04- ============= get Shipping Address
const setShippingAddress = async (
  mage,
  quote,
  address,
  shipping_method,
  am_pickup
) => {
  delete address?.short_address;
  const shipping_address = address;
  const isSave = address?.isSave;
  isSave && delete address.isSave;
  const billing_address = {
    ...address,
    ...(mage && !isSave ? { save_in_address_book: 1 } : {}),
  };

  delete shipping_address.isSave;
  delete billing_address.isSave;

  const now = new Date();
  const year = now.getFullYear();
  const month = now.getMonth();
  const day = now.getDate();
  const date = `${year}-${month + 1}-${day}`;

  let data = {
    addressInformation: {
      shipping_address,
      billing_address,
      shipping_carrier_code: shipping_method,
      shipping_method_code: shipping_method,
    },
  };
  if (am_pickup !== null) {
    data.addressInformation.extension_attributes = {};
    data.addressInformation.extension_attributes.am_pickup = {
      store_id: am_pickup,
      date,
      time_from: now.getTime() + 3 * 60 * 60 * 1000,
      time_to: now.getTime() + 4 * 60 * 60 * 1000,
    };
  }
  let config = {
    method: 'post',
    url: '/cart/shippingaddress',
    headers: {
      quote: 'Bearer ' + quote,
      ...(mage ? { mage: `Bearer ${mage}` } : {}),
    },
    data: JSON.stringify(data),
  };

  try {
    const req = await axios(config);
    return req;
  } catch (error) {
    return error;
  }
};

const placeOrder = async (mage, quote, method, email) => {
  let data = {
    email,
    paymentMethod: {
      method,
    },
  };

  let config = {
    method: 'post',
    url: '/cart/createOrder',
    maxBodyLength: Infinity,
    headers: {
      quote: 'Bearer ' + quote,
      ...(mage ? { mage: `Bearer ${mage}` } : {}),
    },
    data: JSON.stringify(data),
  };
  try {
    const req = await axios(config);
    return req;
  } catch (error) {
    return error;
  }
};
const madfuCrateOrder = async (order_id) => {
  let config = {
    method: 'post',
    url: '/madfu/create-order',
    maxBodyLength: Infinity,
    data: JSON.stringify({ order_id }),
  };

  try {
    const req = await axios(config);
    return req;
  } catch (error) {
    return error;
  }
};
const mispayCrateOrder = async (order_id) => {
  let config = {
    method: 'post',
    url: '/mispay/create-order',
    maxBodyLength: Infinity,
    data: JSON.stringify({ order_id }),
  };
  try {
    const req = await axios(config);
    return req;
  } catch (error) {
    return error;
  }
};

const cardPin = async (mage, quote, firstSixCardNums) => {
  let data = {
    cardPin: firstSixCardNums,
    cartId: quote,
    isMask: mage ? '0' : '1',
  };

  let config = {
    method: 'post',
    url: '/mstore/card-pin',
    maxBodyLength: Infinity,
    data: JSON.stringify(data),
  };
  if (mage) {
    config.headers.mage = 'Bearer ' + mage;
  }
  try {
    const req = await axios(config);
    return req;
  } catch (error) {
    return error;
  }
};

// used in checkout page
const getShippingMethods = async (region_id, city_id, mage, quote) => {
  let config = {
    method: 'GET',
    url: `/mstore/available-shipping-methods-v2/${region_id}/${city_id}/${mage ? '0' : '1'}`,
    headers: {
      quote: `Bearer ${quote}`,
    },
  };

  try {
    const req = await axios(config);

    return req;
  } catch (error) {
    return error;
  }
};

// used in checkout page
const setPaymentMethod = async ({ quote, mage, paymentMethod, email }) => {
  let config = {
    method: 'post',
    url: '/cart/setpaymentmethod',
    headers: {
      quote: `Bearer ${quote}`,
      ...(mage ? { mage: `Bearer ${mage}` } : {}),
    },
    data: JSON.stringify({
      paymentMethod: {
        method: paymentMethod,
      },
      email,
    }),
  };
  try {
    const req = await axios(config);
    return req;
  } catch (error) {
    return error;
  }
};

// ==========> Payfor vault form
const generatePayforVaultForm = (payfortSettings, url) => {
  const paramsArr =
    payfortSettings &&
    Object.entries(payfortSettings).map(([key, value]) => ({ key, value }));

  const form = document.createElement('form');
  form.method = 'POST';
  form.action = url;
  form.id = 'form1';
  form.name = 'form1';

  paramsArr?.forEach(({ key, value }) => {
    const input = document.createElement('input');
    input.id = key;
    input.name = key;
    input.value = value;
    input.type = 'hidden';
    form.appendChild(input);
  });

  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

const pinCard = async (quote, mage, cardPin) => {
  const isMask = quote ? '1' : '0';
  let data = JSON.stringify({
    cardPin,
    cartId: quote,
    isMask,
  });
  let config = {
    method: 'post',
    url: '/mstore/card-pin',
    headers: {
      mage: `Bearer ${mage}`,
    },
    data: data,
  };
  try {
    const req = await axios(config);
    return req;
  } catch (error) {
    return error;
  }
};

export const activeCart = async (order_id) => {
  let config = {
    method: 'post',
    url: '/cart/active',
    data: JSON.stringify({ order_id, device: 'web' }),
  };
  try {
    const req = await axios(config);
    return req;
  } catch (error) {
    return error;
  }
};

const getPaymentOffers = async () => {
  let config = {
    method: 'get',
    url: '/payment/offers',
  };
  try {
    const req = await axios(config);
    return req;
  } catch (error) {
    return error;
  }
};

export {
  getRegions,
  getRegionsV2,
  getUserAddresses,
  setShippingAddress,
  placeOrder,
  madfuCrateOrder,
  mispayCrateOrder,
  cardPin,
  getShippingMethods,
  setPaymentMethod,
  generatePayforVaultForm,
  pinCard,
  getPaymentOffers,
};
